import { t } from "@lingui/macro";
import React from "react";

import { Text, HStack } from "@whoosh/design-system/src/components/primitive";

type QueueSlotHeaderProps = {
  time?: string;
};

export const QueueSlotHeader = ({ time }: QueueSlotHeaderProps) => {
  return (
    <HStack justifyContent="space-between" alignItems="center">
      <Text
        maxFontSizeMultiplier={2}
        mr={4}
        variant="mainBaseMedium"
        color="text-primary"
      >
        {time ? t`Requested:` : ""}
      </Text>
      <HStack>
        {time ? (
          <Text maxFontSizeMultiplier={2} variant="mainBaseSemiBold">
            {time}
          </Text>
        ) : null}
      </HStack>
    </HStack>
  );
};
